import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["sidebar", "toggler", "closer"];

  connect() {
    this.setupToggle();
  }

  setupToggle() {
    this.togglerTarget.addEventListener("click", () => {
      this.sidebarTarget.classList.toggle("show-sidebar-mobile");
    });

    this.closerTarget.addEventListener("click", () => {
      this.sidebarTarget.classList.remove("show-sidebar-mobile");
    });
  }
}
